define([
    'base', 'booking', 'booking_widget', 'booking_stepone', 'booking_steptwo', 'booking_stepthree',
    'campaign', 'dirrty', 'postslist', 'certificate', 'quotation', 'countries', 'flexmenu', 'expatriate',
    'techequip', 'yearlyproduct', 'replace',
    'healthdeclaration', 'nhcpayment', 'monitorpage', 'responsive_swipe', 'claims_widget', 'pricecheck',
    'pagination_simple', 'auth', 'erv_pricebreakdown', 'fileuploadhelper', 'ajax_helper', 'tabs', 'hero_image'
], function (
    base, booking, booking_widget, booking_stepone, booking_steptwo, booking_stepthree,
    campaign, dirrty, postslist, certificate, quotation, countries, flexmenu, expatriate,
    techequip, yearlyproduct, replace,
    healthdeclaration, nhcpayment, monitorpage, responsive_swipe, claims_widget, pricecheck,
    pagination_simple, auth, erv_pricebreakdown, fileuploadhelper, ajax_helper, tabs, hero_image,
) {
    return {
        'base': base,
        'booking': booking,
        'booking_widget': booking_widget,
        'booking_stepone': booking_stepone,
        'booking_steptwo': booking_steptwo,
        'booking_stepthree': booking_stepthree,
        'campaign': campaign,
        'dirrty': dirrty,
        'postslist': postslist,
        'certificate': certificate,
        'quotation': quotation,
        'countries': countries,
        'flexmenu': flexmenu,
        'expatriate': expatriate,
        'techequip': techequip,
        'yearlyproduct': yearlyproduct,
        'replace': replace,
        'healthdeclaration': healthdeclaration,
        'nhcpayment': nhcpayment,
        'monitorpage': monitorpage,
        'responsive_swipe': responsive_swipe,
        'claims_widget': claims_widget,
        'pricecheck': pricecheck,
        'pagination_simple': pagination_simple,
        'auth': auth,
        'erv_pricebreakdown': erv_pricebreakdown,
        'fileuploadhelper': fileuploadhelper,
        'ajax_helper': ajax_helper,
        'tabs': tabs,
        'hero_image': hero_image,
    }
});
